import React from "react";
import {ValueValidator} from "../Validator";
import {CustomInputField} from "../../customInputField/CustomInputField";
import {RootState} from "../../../../app/store";
import {DependantValidationComponent} from "./DependantValidationComponent";
import {OnValidChangeHandler} from "../component/ValidationComponent";

interface Props<PROPERTY, OBJECT> {
    required?: boolean
    validator: ValueValidator<PROPERTY>
    selector: (state: RootState) => PROPERTY | undefined
    anchorValueSelector: (state: RootState) => any | undefined
    fieldName: keyof OBJECT
    onChange: (value: PROPERTY) => any
    updateValidationStatus: OnValidChangeHandler<OBJECT>
    label: string
    placeholder?: string
    disabled?: boolean
    getMessage: (f: string) => string
}

export const DependantValidatedInputField = <PROPERTY, OBJECT>({
                                                                   validator,
                                                                   selector,
                                                                   anchorValueSelector,
                                                                   fieldName,
                                                                   onChange,
                                                                   updateValidationStatus,
                                                                   label,
                                                                   placeholder,
                                                                   disabled,
                                                                   getMessage,
                                                                   required = true
                                                               }: Props<PROPERTY, OBJECT>) => {
    return <DependantValidationComponent<PROPERTY, OBJECT>
        onChange={onChange}
        updateValidationStatus={updateValidationStatus}
        fieldName={fieldName}
        required={required}
        selector={selector}
        anchorValueSelector={anchorValueSelector}
        disabled={disabled}
        validator={validator}
        label={label}
        child={(label, value, onChange, required) =>
            <CustomInputField
                isRequired={required}
                title={label}
                value={value}
                disabled={disabled}
                setValue={onChange}
                placeholder={placeholder}
                errorMessage={getMessage(fieldName as string)}
            />
        }
    />
}
